<template>
  <img class="logo-ekco for-light" src="@/assets/logo-gradient.png" alt="Ekco Logo" />
  <img class="logo-ekco for-dark" src="@/assets/logo-white-glow.png" alt="Ekco Logo" />
</template>
<style lang="scss" scoped>
.logo-ekco {
  height: 3rem;
  width: auto;
}

.for-light {
  display: block;
}

.for-dark {
  display: none;
}

[data-bs-theme='dark'] {
  .for-light {
    display: none;
  }

  .for-dark {
    display: block;
  }
}
</style>
